import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "../../data/content";

const LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Commercial", to: "/commercial" },
  { label: "Residential", to: "/residential" },
  { label: "Pricing", to: "/pricing" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-fc-ink text-white pt-20 pb-10 overflow-hidden">
      <div className="mx-auto w-[92%] max-w-[1280px]">
        <div className="grid md:grid-cols-4 gap-10 pb-16">
          <div className="md:col-span-1">
            <div className="inline-block bg-white rounded-lg p-3 mb-5">
              <img src="/fc-logo.png" alt="F&C Air Conditioning" className="h-12 w-auto" />
            </div>
            <p className="text-white/50 max-w-sm text-sm">
              Florida Class A Air Conditioning Contractor providing residential and commercial
              HVAC sales, service, repairs and installation.
            </p>
          </div>

          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-widest text-fc-cyan mb-4">Pages</h4>
            {LINKS.map((l) => (
              <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="block text-white/70 hover:text-white text-sm py-1">
                {l.label}
              </Link>
            ))}
          </div>

          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-widest text-fc-cyan mb-4">Contact</h4>
            <a data-testid="footer-phone" href={BUSINESS.phoneHref} className="flex items-center gap-2 text-white/70 hover:text-white text-sm py-1"><Phone size={14} /> {BUSINESS.phone}</a>
            <a data-testid="footer-email" href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 text-white/70 hover:text-white text-sm py-1 break-all"><Mail size={14} /> {BUSINESS.email}</a>
          </div>

          <div>
            <h4 className="font-mono text-[10px] uppercase tracking-widest text-fc-cyan mb-4">License</h4>
            <p className="text-white/70 text-sm">Class A Contractor</p>
            <p className="font-mono text-white/70 text-sm">{BUSINESS.license}</p>
            <p className="text-white/50 text-xs mt-1">Exp. {BUSINESS.licenseExpiration}</p>
          </div>
        </div>

        <Link
          to="/"
          data-testid="footer-brand"
          className="block w-full text-left font-display font-semibold tracking-tighter leading-none text-outline-light text-[15vw] hover:text-fc-cyan transition-colors"
        >
          F&amp;C AIR
        </Link>

        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row justify-between gap-3 text-white/60 text-xs font-mono">
          <span>© {new Date().getFullYear()} F&amp;C Air Conditioning. All rights reserved.</span>
          <span className="flex items-center gap-4">
            <span>{BUSINESS.domain}</span>
            <Link to="/admin" data-testid="footer-link-admin" className="hover:text-white transition-colors">Admin</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
